<template>
  <nav
    class="md:left-0 md:block md:fixed md:top-0 md:bottom-0 md:overflow-y-auto md:flex-row md:flex-nowrap md:overflow-hidden shadow-xl bg-white flex flex-wrap items-center justify-between relative md:w-64 z-10 py-4 px-6"
  >
    <div
      class="md:flex-col md:items-stretch md:min-h-full md:flex-nowrap px-0 flex flex-wrap items-center justify-between w-full mx-auto"
    >
      <button
        class="cursor-pointer text-black opacity-50 md:hidden px-3 py-1 text-xl leading-none bg-transparent rounded border border-solid border-transparent"
        type="button"
        @click="toggleCollapseShow('bg-white m-2 py-3 px-6')"
      >
        <i class="fas fa-bars"></i>
      </button>

      <router-link
        class="md:block text-left md:pb-2 text-blueGray-600 mr-0 inline-block whitespace-nowrap text-sm uppercase font-bold p-4 px-0"
        to="/"
      >
        抽奖工具
      </router-link>

      <ul class="md:hidden items-center flex flex-wrap list-none">
        <li class="inline-block relative">
          <notification-dropdown />
        </li>
        <li class="inline-block relative">
          <user-dropdown />
        </li>
      </ul>

      <div
        class="md:flex md:flex-col md:items-stretch md:opacity-100 md:relative md:mt-4 md:shadow-none shadow absolute top-0 left-0 right-0 z-40 overflow-y-auto overflow-x-hidden h-auto items-center flex-1 rounded"
        :class="collapseShow"
      >
        <div
          class="md:min-w-full md:hidden block pb-4 mb-4 border-b border-solid border-blueGray-200"
        >
          <div class="flex flex-wrap">
            <div class="w-6/12">
              <router-link
                class="md:block text-left md:pb-2 text-blueGray-600 mr-0 inline-block whitespace-nowrap text-sm uppercase font-bold p-4 px-0"
                to="/"
              >
                抽奖工具
              </router-link>
            </div>
            <div class="w-6/12 flex justify-end">
              <button
                type="button"
                class="cursor-pointer text-black opacity-50 md:hidden px-3 py-1 text-xl leading-none bg-transparent rounded border border-solid border-transparent"
                @click="toggleCollapseShow('hidden')"
              >
                <i class="fas fa-times"></i>
              </button>
            </div>
          </div>
        </div>

        <div v-for="group in visibleMenuGroups" :key="group.section">
          <hr class="my-4 md:min-w-full" />
          <h6
            class="md:min-w-full text-blueGray-500 text-xs uppercase font-bold block pt-1 pb-4 no-underline"
          >
            {{ group.section }}
          </h6>

          <ul class="md:flex-col md:min-w-full flex flex-col list-none md:mb-4">
            <li v-for="item in group.items" :key="item.path" class="items-center">
              <router-link
                :class="[
                  'text-xs uppercase py-3 px-4 mr-4 font-bold block',
                  isActive(item)
                    ? 'text-blue-600 bg-blue-50 rounded-md'
                    : 'text-blueGray-700 hover:text-blueGray-500'
                ]"
                :to="item.path"
                @click="closeMobileMenu"
              >
                <i
                  :class="[
                    `${item.icon} mr-2 text-sm`,
                    isActive(item) ? 'text-blue-500' : 'text-blueGray-300'
                  ]"
                ></i>
                {{ item.label }}
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import NotificationDropdown from "@/components/Dropdowns/NotificationDropdown.vue";
import UserDropdown from "@/components/Dropdowns/UserDropdown.vue";
import { getUserInfo } from "@/utils/auth.js";
import { getVisibleMenuConfig } from "@/utils/rbac.js";

export default {
  data() {
    return {
      collapseShow: "hidden",
    };
  },
  computed: {
    visibleMenuGroups() {
      return getVisibleMenuConfig(getUserInfo());
    },
  },
  methods: {
    toggleCollapseShow(classes) {
      this.collapseShow = classes;
    },
    closeMobileMenu() {
      if (window.innerWidth < 768) {
        this.collapseShow = "hidden";
      }
    },
    isActive(item) {
      const activePaths = item.activePaths || [item.path];
      return activePaths.some((path) => this.$route.path.startsWith(path));
    },
  },
  components: {
    NotificationDropdown,
    UserDropdown,
  },
};
</script>
